import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useInquiry(inquiryId: string) {
    const { data: inquiry, ...rest } = useQuery(queries.inquiry.detail(inquiryId));
    return { inquiry, ...rest };
}

export default useInquiry;
